(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pricing-packages"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function money(cents) {
      return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    }

    function root() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    function initGrid(grid) {
      if (grid.dataset.ppInit) return;
      grid.dataset.ppInit = '1';

      var inputs = Array.prototype.slice.call(grid.querySelectorAll('[data-pp-input]'));
      var subtotalEl = grid.querySelector('[data-pp-subtotal]');
      var savingsEl = grid.querySelector('[data-pp-savings]');
      var totalEl = grid.querySelector('[data-pp-total]');
      var submitBtn = grid.querySelector('[data-pp-submit]');
      var form = grid.querySelector('[data-pp-form]');
      var errorEl = grid.querySelector('[data-pp-error]');

      function recalc() {
        var subtotal = 0;
        var total = 0;
        var count = 0;

        inputs.forEach(function (input) {
          var qty = parseInt(input.value, 10);
          if (isNaN(qty) || qty < 0) qty = 0;

          var price = parseInt(input.dataset.price, 10) || 0;
          var original = parseInt(input.dataset.original, 10) || price;
          var line = price * qty;

          subtotal += original * qty;
          total += line;
          count += qty;

          var card = input.closest('.pp-card');
          var lineEl = card && card.querySelector('[data-pp-line]');
          if (lineEl) lineEl.textContent = money(line);

          var subEl = card && card.querySelector('[data-pp-line-sub]');
          if (subEl) {
            var blockValue = parseInt(input.dataset.blockValue, 10) || 0;
            subEl.textContent = qty > 0 ? money(blockValue * qty) + ' credit' : '';
          }
        });

        var savings = subtotal - total;
        if (subtotalEl) subtotalEl.textContent = money(subtotal);
        if (savingsEl) savingsEl.textContent = (savings > 0 ? '- ' : '') + money(savings);
        if (totalEl) totalEl.textContent = money(total);
        if (submitBtn) submitBtn.disabled = count <= 0;
      }

      inputs.forEach(function (input) {
        input.addEventListener('input', recalc);
        input.addEventListener('change', function () {
          var q = parseInt(input.value, 10);
          if (isNaN(q) || q < 0) input.value = 0;
          recalc();
        });
      });

      function addItems(items, btn) {
        if (!items.length) return;
        if (errorEl) {
          errorEl.hidden = true;
          errorEl.textContent = '';
        }
        if (btn) {
          btn.disabled = true;
          btn.classList.add('is-loading');
        }

        fetch(root() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) {
            if (!r.ok) {
              return r.json().then(function (d) {
                throw new Error(d.description || d.message || 'Sorry, this could not be added to your cart.');
              });
            }
            return r.json();
          })
          .then(function () {
            window.location = root() + 'cart';
          })
          .catch(function (err) {
            if (btn) {
              btn.disabled = false;
              btn.classList.remove('is-loading');
            }
            if (errorEl) {
              errorEl.hidden = false;
              errorEl.textContent = err.message;
            }
          });
      }

      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var items = [];
          inputs.forEach(function (input) {
            var qty = parseInt(input.value, 10) || 0;
            var id = input.dataset.variant;
            if (qty > 0 && id) items.push({ id: id, quantity: qty });
          });
          addItems(items, submitBtn);
        });
      }

      grid.querySelectorAll('[data-pp-card-add]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var card = btn.closest('.pp-card');
          var input = card && card.querySelector('[data-pp-input]');
          if (!input) return;
          var qty = parseInt(input.value, 10);
          if (isNaN(qty) || qty < 1) {
            qty = 1;
            input.value = 1;
            recalc();
          }
          var id = input.dataset.variant;
          if (!id) return;
          addItems([{ id: id, quantity: qty }], btn);
        });
      });

      recalc();
    }

    function scan() {
      document.querySelectorAll('[data-pricing-grid]').forEach(initGrid);
    }

    if (document.readyState !== 'loading') {
      scan();
    } else {
      document.addEventListener('DOMContentLoaded', scan);
    }
    document.addEventListener('shopify:section:load', scan);
  })();

  } catch(e) { console.error(e); }
})();
})();
